import { BeforeInsert, Column, Entity, JoinColumn, OneToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique, FiltrableEntiteStatique, Lieu } from '.';
import { CentreServiceScolaire } from './centre-service-scolaire.entity';
import ClientContact from './client-contact.entity';
import ClientLieu from './client-lieu.entity';

@FiltrableEntiteStatique<Client>()
@EntiteStatique()
@Entity('client')
export class Client implements BaseEntite {
    static key = 'clients';

    static non_privileged_properties: (keyof Client)[] = [];
    static regular_privileged_properties: (keyof Client)[] = ['id', 'name'];
    static admin_privileged_properties: (keyof Client)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ type: 'text' })
    name = '';

    @Column({ type: 'timestamp', nullable: true })
    created_at = '';

    @Column({ nullable: true })
    fk_centre_service_scolaire: number;

    @ManyToOne(() => CentreServiceScolaire)
    @JoinColumn({ name: 'fk_centre_service_scolaire', referencedColumnName: 'id' })
    centre_service_scolaire: CentreServiceScolaire;

    @Column({ type: 'numeric', nullable: true })
    nb_eleves_total: number;

    @Column({ type: 'numeric', nullable: true })
    nb_avg_pedago: number;

    @Column({ type: 'numeric', nullable: true })
    nb_avg_sortie: number;

    @Column({ type: 'numeric', nullable: true })
    nb_sdg_total: number;

    @Column({ type: 'timestamp', nullable: true })
    fin_abonnement = '';

    @Column({ type: 'text', nullable: true })
    notes = '';

    @Column({ nullable: true })
    notes_fournisseur: string;

    @Column({ nullable: true })
    notes_client: string;

    @Column({ type: 'text', nullable: true })
    prefix = '';

    @Column({ type: 'text', default: '' })
    groupe_age = '';

    @Column({ default: '' })
    courriel: string;

    @Column({ default: '' })
    telephone: string;

    @Column({ default: '' })
    grandeur_gym: string;

    @Column({ type: 'numeric', nullable: true })
    nb_groupe_classe: number;

    @Column({ nullable: true })
    roles: string;

    @OneToMany(() => ClientContact, (clientContact: ClientContact) => clientContact.client)
    contacts: ClientContact[];

    @OneToMany(() => ClientLieu, (clientLieu: ClientLieu) => clientLieu.client)
    lieux: ClientLieu[];

    @Column({ nullable: true })
    fk_id_lieu: number;

    @ManyToOne(() => Lieu, { eager: true })
    @JoinColumn({ name: 'fk_id_lieu', referencedColumnName: 'id' })
    adresse_facturation: Lieu;

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}
